import loadable from '@loadable/component';

import './Press.css';

export default loadable(() => {
  return import('./Press.jsx');
});
